import { render } from "./Palette.vue?vue&type=template&id=12acc34c&scoped=true"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"

import "./Palette.vue?vue&type=style&index=0&id=12acc34c&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12acc34c"]])

export default __exports__